import { HFlow, Text, VFlow } from 'bold-ui'
import { LoadingIndicator } from 'components/loading'
import { useHistoricoCuidadoCompartilhadoLotacaoAfetadaQuery } from 'graphql/hooks.generated'

interface HistoricoCuidadoCompartilhadoTrocaProfissionalReferenciaProps {
  cuidadoCompartilhadoEvolucaoId: ID
  descricao?: string
}

export function HistoricoCuidadoCompartilhadoTrocaProfissionalReferencia(
  props: HistoricoCuidadoCompartilhadoTrocaProfissionalReferenciaProps
) {
  const { cuidadoCompartilhadoEvolucaoId, descricao } = props

  const { loading, data } = useHistoricoCuidadoCompartilhadoLotacaoAfetadaQuery({
    variables: { id: cuidadoCompartilhadoEvolucaoId },
  })

  if (loading) return <LoadingIndicator />

  const lotacaoAfetada = data?.cuidadoCompartilhadoEvolucao?.lotacaoAfetada
  if (!lotacaoAfetada) return null

  const equipe = lotacaoAfetada.equipe
  const profissional = lotacaoAfetada.profissional

  return (
    <VFlow vSpacing={0.25}>
      <HFlow hSpacing={0.25}>
        <Text fontWeight='bold'>
          Encaminhou para {profissional.nome}
          <Text fontWeight='normal'>
            {!!profissional.nomeSocial && ' (Nome social)'}
            {` | ${lotacaoAfetada.cbo.nome.toUpperCase()}`}
            {!!equipe && ` | Equipe ${equipe.ine} - ${equipe.nome}`}
            {!!profissional.nomeSocial && ` | Nome civil - ${profissional.nomeCivil}`}
          </Text>
        </Text>
      </HFlow>
      <HFlow hSpacing={0.25}>
        <Text fontWeight='bold'>Motivo: </Text>
        <Text dangerouslySetInnerHTML={{ __html: descricao }} />
      </HFlow>
    </VFlow>
  )
}
